import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RegisterPageComponent } from '@app/accounts/register-page/register-page.component';
import { GuestGuard } from '@app/core/guest-guard.service';
import { ChangePasswordComponent } from '@app/accounts/change-password/change-password.component';
import { AuthGuard } from '@app/core/auth-guard.service';
import { ForgotPasswordComponent } from '@app/accounts/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from '@app/accounts/reset-password/reset-password.component';
import { AuthPageComponent } from '@app/accounts/auth-page/auth-page.component';
import { LogoutComponent } from '@app/accounts/logout/logout.component';

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'login' },
  { path: 'login', component: AuthPageComponent, canActivate: [ GuestGuard ] },
  { path: 'register', component: RegisterPageComponent, canActivate: [ GuestGuard ], data: { section: 'register' } },
  { path: 'info', component: RegisterPageComponent, canActivate: [ AuthGuard ], data: { section: 'after-register' } },
  { path: 'password/change', component: ChangePasswordComponent, canActivate: [ AuthGuard ] },
  { path: 'forgot', component: ForgotPasswordComponent, canActivate: [ GuestGuard ] },
  { path: 'reset/:token', component: ResetPasswordComponent, canActivate: [ GuestGuard ] },
  { path: 'logout', component: LogoutComponent, canActivate: [AuthGuard]}
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
  ],
  exports: [
    RouterModule,
  ],
})
export class AccountsRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/accounts/accounts-routing.module.ts